import React, { useEffect } from "react";

import BeforeCaptionSubmit from "../components/BeforeCaptionSubmit";
import AfterCaptionSubmit from "../components/AfterCaptionSubmit";

const Showcase = ({
  photo,
  roomId,
  caption,
  mobile_app,
  set_caption,
  userCaption,
  cc_countdown,
  currentPlayer,
  deadline_time,
  showcase_params,
  set_cc_countdown
}) => {
  useEffect(() => {
    if (!!deadline_time) {
      const current_time_seconds = new Date();
      const dead_line_time_seconds = new Date(deadline_time);
      const seconds = Math.ceil(
        (dead_line_time_seconds - current_time_seconds) / 1000
      );
      if (seconds > 0) {
        set_cc_countdown(seconds);
      } else {
        set_cc_countdown(0);
      }
    }
  }, [deadline_time]);

  useEffect(() => {
    if (!!cc_countdown) {
      if (cc_countdown === 5 && userCaption === undefined) {
        if (mobile_app) {
          const message = {
            action: "vibrate"
          };
          window.parent.postMessage(message, "*");
        } else {
          const canVibrate = window.navigator.vibrate;
          if (canVibrate) window.navigator.vibrate(500);
        }
      }
      let timer;
      timer =
        cc_countdown > 0 &&
        setInterval(() => set_cc_countdown(cc_countdown - 1), 1000);
      return () => clearInterval(timer);
    }
  }, [cc_countdown]);

  return userCaption === undefined ? (
    <BeforeCaptionSubmit
      photo={photo}
      roomId={roomId}
      caption={caption}
      mobile_app={mobile_app}
      set_caption={set_caption}
      cc_countdown={cc_countdown}
      currentPlayer={currentPlayer}
      deadline_time={deadline_time}
      showcase_params={showcase_params}
      set_cc_countdown={set_cc_countdown}
    />
  ) : (
    <AfterCaptionSubmit
      mobile_app={mobile_app}
      cc_countdown={cc_countdown}
      deadline_time={deadline_time}
      showcase_params={showcase_params}
      set_cc_countdown={set_cc_countdown}
    />
  );
};

export default Showcase;
